import React, { useEffect, useState } from 'react';
import Modal from 'components/ui/Modal';
import Button from 'components/ui/Button';
import { motivoValido } from 'lib/auditoria';
import { mensajeError } from 'lib/errores';

// Confirmación con motivo obligatorio (5+ caracteres). Para anular una
// inspección, marcar un día sin operación o anular esa marca. Es un
// formulario con texto: tocar el fondo NO lo cierra (cerrarConFondo={false}).
// onConfirm(motivo) devuelve una promesa; si lanza, el error se muestra aquí.
export default function MotivoDialog({
  open, onClose, titulo, descripcion, etiqueta = 'Motivo', confirmar = 'Confirmar', peligro = false, onConfirm,
}) {
  const [motivo, setMotivo] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { if (open) { setMotivo(''); setError(''); setEnviando(false); } }, [open]);

  const valido = motivoValido(motivo);
  const enviar = async () => {
    if (!valido || enviando) return;
    setEnviando(true);
    setError('');
    try {
      await onConfirm(motivo.trim());
      onClose();
    } catch (e) {
      setError(mensajeError(e, 'No se pudo completar la acción.'));
      setEnviando(false);
    }
  };

  return (
    <Modal open={open} onClose={enviando ? () => {} : onClose} title={titulo} maxWidth="max-w-md" cerrarConFondo={false}
      footer={(
        <div className="flex gap-2">
          <Button type="button" variant="outline" size="lg" className="flex-1 px-4" onClick={onClose} disabled={enviando}>
            Cancelar
          </Button>
          <Button type="button" variant={peligro ? 'danger' : 'default'} size="lg" className="flex-1 px-4"
            onClick={enviar} disabled={!valido} loading={enviando}>
            {confirmar}
          </Button>
        </div>
      )}>
      {descripcion && <div className="mb-3 text-sm leading-snug text-foreground">{descripcion}</div>}
      <label className="flex flex-col gap-1 text-sm font-medium text-foreground">
        {etiqueta}
        <textarea value={motivo} onChange={(e) => setMotivo(e.target.value)} rows={3} data-autofocus
          className="rounded-lg border border-input bg-white px-2.5 py-2 text-sm text-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/25"
          placeholder="Escriba el motivo (mínimo 5 caracteres)" />
      </label>
      {!valido && motivo.trim().length > 0 && (
        <p className="mt-1 text-xs text-muted-foreground">Faltan {5 - motivo.trim().length} caracteres.</p>
      )}
      {error && <p role="alert" className="mt-2 rounded-lg bg-error/10 px-2.5 py-2 text-sm text-error">{error}</p>}
    </Modal>
  );
}
